export default "__VITE_ASSET__DajTmTGJ__"